import React, { useState } from 'react';
import { string, number } from 'prop-types';
import Loader from '../Loader';

const Image = ({ src, alt, className, width, height, ...attrs }) => {
  const [imgLoaded, setImgLoaded] = useState(false)

  return (
    <>
      {!imgLoaded && <Loader />}
      <img
        src={src}
        alt={alt}
        onLoad={() => setImgLoaded(true)}
        className={!imgLoaded ? `${className} hide` : className}
        {...attrs}
      />
    </>
  )
}

Image.propTypes = {
  src: string.isRequired,
  alt: string,
  width: number,
  height: number,
};

Image.defaultProps = {
  alt: 'image',
  width: 100,
  height: 100,
  className: '',
};

export default Image